<template>
  <div class="page-heading header-text">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>Our Services</h1>
          <span>We are over 20 years of experience</span>
        </div>
      </div>
    </div>
  </div>
  <div class="single-services">
    <div class="container">
      <div class="row" id="tabs">
        <div class="col-md-4">
          <ul>
            <li class="" :class="{ active: activeTab === 'tabs-1' }">
              <a @click="activeTab = 'tabs-1'">Telecoms & ICT sales <i class="fa fa-angle-right"></i></a>
            </li>
            <li :class="{ active: activeTab === 'tabs-2' }">
              <a @click="activeTab = 'tabs-2'">ICT Solution Sales <i class="fa fa-angle-right"></i></a>
            </li>
            <li :class="{ active: activeTab === 'tabs-3' }">
              <a @click="activeTab = 'tabs-3'">Fixed Network FTTH design <i class="fa fa-angle-right"></i></a>
            </li>
            <li :class="{ active: activeTab === 'tabs-4' }">
              <a @click="activeTab = 'tabs-4'">Implementation Sales <i class="fa fa-angle-right"></i></a>
            </li>
            <li :class="{ active: activeTab === 'tabs-5' }">
              <a @click="activeTab = 'tabs-5'">Satellite Solutions Broadcast & Digital Media <i
                  class="fa fa-angle-right"></i></a>
            </li>
          </ul>
        </div>
        <div class="col-md-8">
          <section class="tabs-content">
            <article v-if="activeTab === 'tabs-1'" id="tabs-1">
              <img src="../assets/service_01.jpg" alt="" />
              <h4>Telecoms & ICT sales</h4>
              <p>
                Telecoms & ICT sales focus on delivering advanced communication and technology solutions tailored to
                client needs. This sector encompasses a range of products, including phones, network equipment, and
                software, designed to enhance connectivity and data management. Sales professionals work to understand
                customer requirements, offering customized solutions that drive efficiency and growth. <br /><br />In
                this dynamic field, building strong relationships and maintaining a deep knowledge of emerging
                technologies are crucial. Successful sales strategies involve not only promoting products but also
                providing exceptional service and support throughout the sales process. By aligning solutions with
                client goals, Telecoms & ICT sales professionals help businesses stay competitive in a rapidly evolving
                digital landscape.
              </p>
            </article>
            <article v-if="activeTab === 'tabs-2'" id="tabs-2">
              <img src="../assets/service_04.png" alt="" />
              <h4>ICT Solution Sales</h4>
              <p>
                ICT Solution Sales involves selling integrated technology solutions that address a range of business
                needs. This includes hardware, software, and services designed to enhance IT infrastructure, streamline
                operations, and improve overall efficiency. Sales professionals in this field focus on understanding
                client requirements and offering tailored solutions that drive innovation and growth.
                <br /><br />Key responsibilities include identifying opportunities, demonstrating product benefits, and
                providing ongoing support to ensure successful implementation. By staying abreast of technological
                advancements and market trends, ICT Solution Sales experts help organizations leverage technology to
                achieve their strategic goals and stay ahead of the competition.
              </p>
            </article>
            <article v-if="activeTab === 'tabs-3'" id="tabs-3">
              <img src="../assets/service_02.jpg" alt="" />
              <h4>Fixed Network FTTH design</h4>
              <p>
                Fixed Network FTTH (Fiber to the Home) design involves creating a robust infrastructure for delivering
                high-speed internet directly to residential homes via fiber optics. This design focuses on optimizing
                network performance by carefully planning the routes, selecting appropriate equipment, and implementing
                efficient installation strategies. The goal is to ensure reliable, high-bandwidth connections that meet
                the growing demands for fast and stable internet access. <br /><br />Key elements of the design include
                minimizing signal loss, maximizing network efficiency, and planning for future scalability. By
                addressing these factors, FTTH design aims to provide a future-proof solution that supports seamless
                communication and data transfer. This approach helps in building a dependable network that can adapt to
                evolving technological needs and consumer expectations.
                condimentum.
              </p>
            </article>
            <article v-if="activeTab === 'tabs-4'" id="tabs-4">
              <img src="../assets/service_05.jpg" alt="" />
              <h4>Implementation Sales</h4>
              <p>
                Implementation Sales involves guiding clients through the process of adopting and deploying technology
                solutions. This role focuses on understanding customer requirements, presenting tailored solutions, and
                managing the installation and integration phases to ensure a smooth transition. Sales professionals in
                this field collaborate with technical teams to address any challenges and ensure that the solutions meet
                performance and efficiency goals. <br /><br />Key responsibilities include demonstrating the value of
                the solution, coordinating project timelines, and providing post-implementation support to optimize user
                experience. By effectively managing these aspects, Implementation Sales professionals help clients
                realize the full potential of their technology investments and achieve their business objectives.
              </p>
            </article>
            <article v-if="activeTab === 'tabs-5'" id="tabs-4">
              <img src="../assets/service_03.jpg" alt="" />
              <h4>Satellite Solutions Broadcast & Digital Media</h4>
              <p>
                Satellite Solutions for Broadcast & Digital Media provide high-quality, reliable transmission of
                television, radio, and digital content via satellite. These solutions enable global content
                distribution, ensuring broad reach and seamless delivery of media. They are essential for broadcasting
                live events, distributing television channels, and streaming digital content to diverse audiences
                worldwide. <br /><br />With capabilities for high-definition and multi-channel broadcasting, satellite
                solutions support media companies in delivering consistent and uninterrupted service. They also offer
                flexible and scalable options for expanding media reach and integrating new technologies, helping
                broadcasters and content providers stay competitive in a rapidly evolving digital landscape.
              </p>
            </article>
          </section>
        </div>
      </div>
    </div>
  </div>
  <CallbackRequestCard class="mb-4" />
  <!-- <PartnersCard /> -->
</template>

<script>
import CallbackRequestCard from "@/components/CallbackRequestCard.vue";

export default {
  name: "ServicesView",
  components: {
    CallbackRequestCard,
  },
  data() {
    return {
      activeTab: "tabs-1",
    };
  },
};
</script>
<style scoped>
ul li a{
  color: white !important;
  background: blue;
  cursor: pointer;
}
.active a {
  color: blue !important;
  background: white !important;
  border: 1px solid #007bff !important;
  border-radius: 2%;
}
article img {
  height: 500px;
  width: 100%;
}
</style>
